"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./mobileBottomShareSheet.scss");
const linkedin_logo_white_png_1 = __importDefault(require("../../../../../assets/images/socialIcons/linkedin-logo-white.png"));
const share_icon_svg_1 = __importDefault(require("../../../../../assets/images/icons/share-icon.svg"));
const dynamic_close_icon_svg_1 = __importDefault(require("../../../../../assets/images/icons/dynamic-close-icon.svg"));
const BaseButton_1 = __importDefault(require("../../../../../elementKit/baseButton/BaseButton"));
const react_svg_1 = require("react-svg");
const ActionShareButtons_1 = __importDefault(require("../actionShareButtons/ActionShareButtons"));
const react_detect_click_outside_1 = require("react-detect-click-outside");
function MobileBottomShareSheet(props) {
    const [showShareSheet, setShowShareSheet] = react_1.default.useState(false);
    const linkedinShareRowRef = react_1.default.useRef(null);
    const [linkedinButtonWidth, setLinkedinButtonWidth] = react_1.default.useState(0);
    const [isExpanded, setIsExpanded] = react_1.default.useState(false);
    const [isFooterVisible, setIsFooterVisible] = react_1.default.useState(false);
    const [isScrolling, setIsScrolling] = react_1.default.useState(false);
    const triggerRef = (0, react_detect_click_outside_1.useDetectClickOutside)({
        onTriggered: () => {
            if (!isScrolling) {
                setShowShareSheet(false);
            }
        },
    });
    function getShareLinkedinButtonWidth() {
        const widthToCalculate = linkedinShareRowRef.current
            ? linkedinShareRowRef.current.clientWidth - 56.33 - 10
            : 0;
        if (widthToCalculate !== linkedinButtonWidth) {
            setLinkedinButtonWidth(widthToCalculate);
        }
    }
    (0, react_1.useEffect)(() => {
        const handleTouchStart = () => {
            setIsScrolling(false);
        };
        const handleTouchMove = () => {
            setIsScrolling(true);
        };
        window.addEventListener("touchstart", handleTouchStart);
        window.addEventListener("touchmove", handleTouchMove);
        return () => {
            window.removeEventListener("touchstart", handleTouchStart);
            window.removeEventListener("touchmove", handleTouchMove);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        getShareLinkedinButtonWidth();
    }, [linkedinShareRowRef, showShareSheet]);
    function expandForSocialShares() {
        setIsExpanded(!isExpanded);
    }
    (0, react_1.useEffect)(() => {
        const handleScroll = () => {
            if (!isFooterVisible) {
                if (window.scrollY > 100) {
                    setShowShareSheet(true);
                }
                else {
                    setShowShareSheet(false);
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        const footer = document.getElementById("hybrid-footer");
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setShowShareSheet(false);
                    setIsFooterVisible(true);
                }
                else {
                    setIsFooterVisible(false);
                    handleScroll();
                }
            });
        }, { threshold: [0] });
        if (footer) {
            observer.observe(footer);
        }
        return () => {
            window.removeEventListener("scroll", handleScroll);
            if (footer) {
                observer.unobserve(footer);
            }
        };
    }, [isFooterVisible]);
    return (react_1.default.createElement("div", { id: "mobile-bottom-share-sheet", style: {
            display: showShareSheet ? "flex" : "none",
        }, ref: triggerRef },
        react_1.default.createElement("span", { className: "share-title" }, "Share Your Credential"),
        react_1.default.createElement("div", { className: "linkedin-share-row", ref: linkedinShareRowRef },
            react_1.default.createElement(BaseButton_1.default, { type: "primary", size: "small", loading: false, width: linkedinButtonWidth, disabled: props.isDisabledByMandatoryClaiming, height: 50, className: "full-width-mobile-btn", primaryColor: "#0072B1", disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), onClickAction: () => {
                    props.handleLinkedinClickOpen();
                } }, props.activeLanguage && props.activeLanguage.code === "tr" ? (react_1.default.createElement("div", { className: "flex-row jc-c ai-fe" },
                react_1.default.createElement("img", { alt: "LinkedIn Logo", className: "linkedin-logo white", src: linkedin_logo_white_png_1.default, width: "75", height: "20", loading: "lazy", style: { marginRight: "5px" } }),
                react_1.default.createElement("span", null, props.translate("addToLinkedin").toString()))) : (react_1.default.createElement("div", { className: "flex-row jc-c ai-fe" },
                react_1.default.createElement("span", null, props.translate("addToLinkedin").toString()),
                " ",
                react_1.default.createElement("img", { alt: "LinkedIn Logo", className: "linkedin-logo white", src: linkedin_logo_white_png_1.default, style: { marginLeft: "5px" }, width: "75", height: "20", loading: "lazy" })))),
            react_1.default.createElement(BaseButton_1.default, { size: "small", height: 50, width: 56.33, onClickAction: (event) => {
                    event.stopPropagation();
                    expandForSocialShares();
                }, type: "secondary", loading: false }, isExpanded ? (react_1.default.createElement(react_svg_1.ReactSVG, { src: dynamic_close_icon_svg_1.default, className: "customizable-icon close-icon", wrapper: "span", afterInjection: (svg) => {
                    svg.setAttribute("height", "30px");
                    svg.setAttribute("width", "30px");
                    svg.style.width = "30px";
                    svg.style.height = "30px";
                }, width: 20, height: 20 })) : (react_1.default.createElement(react_svg_1.ReactSVG, { src: share_icon_svg_1.default, className: "customizable-icon share-icon", wrapper: "svg", height: 20, width: 20 })))),
        react_1.default.createElement("div", { className: `socials-row ${isExpanded ? "expanded" : "collapsed"}` },
            react_1.default.createElement(ActionShareButtons_1.default, Object.assign({ isMobile: true }, props)))));
}
exports.default = MobileBottomShareSheet;
